import { defineTour } from '@lopettia/simul';

/**
 * Closer (Sales Representative) — happy-path day-in-the-life:
 * dashboard → opportunities → opportunity detail → Demos tab →
 * quick-create a demo via the Closer 3-step sheet → handoff to
 * Pre-Sales → WhatsApp share. Mirrors docs/manuals/01-sales-representative.md.
 */
export const salesRepresentativeTour = defineTour({
  name: 'Closer day-in-the-life',
  description:
    'Walks a sales representative through their dashboard, opportunity workflow, '
    + 'and the Closer-side demo handoff to Pre-Sales.',
  steps: [
    {
      id: 'sr-dashboard',
      kind: 'info',
      target: '[data-tour-id="nav-dashboard"]',
      prelude: { goto: '/dashboard' },
      message:
        '**Welcome, Closer.** Your dashboard is the daily snapshot of pipeline '
        + 'health, demo conversion, and follow-ups due today.',
      advanceOn: 'manual',
      spotlight: true,
    },
    {
      id: 'sr-open-opps',
      kind: 'navigate',
      target: '[data-tour-id="nav-opportunities"]',
      toUrl: '/opportunities',
      message: 'Click **Opportunities** to see every deal assigned to you.',
      advanceOn: 'navigate',
    },
    {
      id: 'sr-opps-list',
      kind: 'info',
      target: '[data-tour-id="opportunities-list"]',
      message:
        'Filter, group, and prioritise. Open any row to drill into the deal.',
      advanceOn: 'manual',
    },
    {
      id: 'sr-opp-detail',
      kind: 'info',
      target: '[data-tour-id="opportunity-detail-header"]',
      message:
        'The opportunity detail page surfaces stage, stakeholders, activity, '
        + 'and the **Demos** tab where Pre-Sales builds the prospect demo.',
      advanceOn: 'manual',
    },
    {
      id: 'sr-demos-tab',
      kind: 'click',
      target: '[data-tour-id="opportunity-tab-demos"]',
      message: 'Open the **Demos** tab to request a demo from Pre-Sales.',
      advanceOn: 'click',
    },
    {
      id: 'sr-create-demo',
      kind: 'click',
      target: '[data-tour-id="demo-create-cta"]',
      message:
        'Click **Create demo** to launch the Closer 3-step sheet — '
        + 'pick template → confirm prospect → choose Pre-Sales owner.',
      advanceOn: 'click',
    },
    {
      id: 'sr-handoff',
      kind: 'info',
      target: '[data-tour-id="demo-handoff-summary"]',
      message:
        'Pre-Sales is now notified and will build the demo. You will be '
        + 'pinged when it is ready to share.',
      advanceOn: 'manual',
    },
    {
      id: 'sr-share-wa',
      kind: 'info',
      target: '[data-tour-id="demo-share-whatsapp"]',
      message:
        'Once published, **Share via WhatsApp** copies the prospect-ready link '
        + 'into a templated message your prospect can open on mobile.',
      advanceOn: 'manual',
    },
  ],
});

export default salesRepresentativeTour;
